import React from 'react';
import { auth } from '../firebase/config';

const Header = ({ title, navigateTo, currentPage }) => {
    return (
        <header className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-8 pb-4 border-b gap-4">
            <h1 className="text-3xl font-bold text-gray-800 whitespace-nowrap">{title}</h1>
            <nav className="flex flex-wrap gap-2">
                {currentPage !== 'budget' && (
                    <button onClick={() => navigateTo('budget')} className="px-4 py-2 font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                        Budget
                    </button>
                )}
                {currentPage !== 'profile' && (
                    <button onClick={() => navigateTo('profile')} className="px-4 py-2 font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                        Profile
                    </button>
                )}
                {currentPage !== 'help' && (
                     <button onClick={() => navigateTo('help')} className="px-4 py-2 font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                        Help
                    </button>
                )}
                <button onClick={() => auth.signOut()} className="px-4 py-2 font-medium text-white bg-gray-600 rounded-md hover:bg-gray-700">
                    Sign Out
                </button>
            </nav>
        </header>
    );
};

export default Header;